// extracted by css-extract-rspack-plugin
export default {"richContent":"_U8xi0ePzLIJYWeL"};